import React from 'react';
import MemberCard from "./MemberCard";

class MemberList extends React.Component {

    static defaultProps = {
        onClick: () => {},
        members: [],
        categories: []
    }

    render() {

        const {
            categories,
            members,
            onClick
        } = this.props;

        return (
            <div className="">
                {members.map((member, index) => {
                    return (
                        <MemberCard
                            key={'membercard_' + index + '_' + member.member_id}
                            categories={categories}
                            member={member}
                            onClick={() => {
                                onClick(member, index)
                            }}
                        />
                    )
                })}
            </div>
        )
    }

}

export default MemberList;
